const initialState = {
    //organisation purchase invoice data
    loadingOrganisationsPurchaseInvoiceData: false,
    OrganisationsPurchaseInvoiceDataError: '',
    OrganisationsPurchaseInvoiceData: [],

    //tradeinvoice rcm
    loadingCreditNoteList: false,
    CreditNoteList: [],
    CreditNoteListError: '',
    CreditNoteListCurrentPage: 0,
    CreditNoteListTotalPage: 0,
    CreditNoteListTotalData: 0,


    //rcm view
    loadingCreditNoteView: false,
    CreditNoteView: {},
    CreditNoteViewError: '',
}

const TradeInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {

        //organisation purchase invoice data details//
        case 'FIND_ORGANISATION_PURCHASE_INVOICE_REQUEST':
            return {
                ...state,
                loadingOrganisationsPurchaseInvoiceData: true,
                OrganisationsPurchaseInvoiceDataError: '',
                OrganisationsPurchaseInvoiceData: [],
            };
        case 'FIND_ORGANISATION_PURCHASE_INVOICE_SUCCESS':
            return {
                ...state,
                loadingOrganisationsPurchaseInvoiceData: false,
                OrganisationsPurchaseInvoiceDataError: '',
                OrganisationsPurchaseInvoiceData: action.payload,
            };
        case 'FIND_ORGANISATION_PURCHASE_INVOICE_FAILURE':
            return {
                ...state,
                loadingOrganisationsPurchaseInvoiceData: false,
                OrganisationsPurchaseInvoiceDataError: action.payload,
                OrganisationsPurchaseInvoiceData: [],
            };
        //organisation purchase invoice data details//

        //tradeinvoice rcm
        case 'FIND_CREDIT_NOTE_REQUEST':
            return {
                ...state,
                loadingCreditNoteList: true,
                CreditNoteList: [],
                CreditNoteListError: '',
                CreditNoteListCurrentPage: 0,
                CreditNoteListTotalPage: 0,
                CreditNoteListTotalData: 0,
            };
        case 'FIND_CREDIT_NOTE_SUCCESS':
            return {
                ...state,
                loadingCreditNoteList: false,
                CreditNoteList: action.payload.data,
                CreditNoteListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                CreditNoteListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                CreditNoteListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
            };
        case 'FIND_CREDIT_NOTE_FAILURE':
            return {
                ...state,
                loadingCreditNoteList: false,
                CreditNoteList: [],
                CreditNoteListError: action.payload,
                CreditNoteListCurrentPage: 1,
                CreditNoteListTotalPage: 0,
                CreditNoteListTotalData: 0,
            };
        //tradeinvoice rcm

        //rcm view
        case 'FIND_CREDIT_NOTE_VIEW_REQUEST':
            return {
                ...state,
                loadingCreditNoteView: true,
                CreditNoteView: {},
                CreditNoteViewError: '',

            };
        case 'FIND_CREDIT_NOTE_VIEW_SUCCESS':
            return {
                ...state,
                loadingCreditNoteView: false,
                CreditNoteView: action.payload.data,

            };
        case 'FIND_CREDIT_NOTE_VIEW_FAILURE':
            return {
                ...state,
                loadingCreditNoteView: false,
                CreditNoteView: {},
                CreditNoteViewError: action.payload,

            };
        //rcm view


        default:
            return state;
    }
}

export default TradeInvoiceReducer;